import React from 'react';
import { AppBar, Toolbar, Typography, IconButton, Box, Button, Tooltip } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';
import { useAuth } from '../../context/AuthContext';
import { useBusiness } from '../../context/BusinessContext';
import { useNavigate } from 'react-router-dom';

const Header = ({ onMenuClick }) => {
  const { user, logout } = useAuth();
  const { businessName } = useBusiness();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <AppBar
      position="fixed"
      sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
    >
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={onMenuClick}
          sx={{ mr: 2, display: { sm: 'none' } }}
        >
          <MenuIcon />
        </IconButton>
        {/* minWidth 0 lets a long business name truncate instead of pushing Logout off-screen. */}
        <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1, minWidth: 0 }}>
          {businessName}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexShrink: 0 }}>
          {/* On a phone the name competes with the business name for one line; the
              signed-in user is already implied by being in the app. */}
          <Typography variant="body1" sx={{ display: { xs: 'none', sm: 'block' } }}>
            {user?.first_name || user?.username}
          </Typography>
          <Button
            color="inherit"
            startIcon={<LogoutIcon />}
            onClick={handleLogout}
            sx={{ display: { xs: 'none', sm: 'inline-flex' } }}
          >
            Logout
          </Button>
          <Tooltip title="Logout">
            <IconButton
              color="inherit"
              edge="end"
              aria-label="Logout"
              onClick={handleLogout}
              sx={{ display: { xs: 'inline-flex', sm: 'none' } }}
            >
              <LogoutIcon />
            </IconButton>
          </Tooltip>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
